<script>
import {mapActions, mapGetters} from 'vuex';
import {http} from "@/plugins/http";
import {UI_MAP_READY} from "@/shared/components/map-viewer/constants/map-events";

export default {
    name: "OSurveillanceController",

    data() {
        return {
            mapStartLoadingTime: 0,
            localHeartbeatIntervalPointer: null,
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp',
        ]),
        localHeartbeatInterval(){
            return this.getMapConfigProp('features.surveillance.local_heartbeat.interval', 60000)
        },
        localHeartbeatUrl(){
            return this.getMapConfigProp('features.surveillance.local_heartbeat.url', false)
        }
    },
    methods: {
        ...mapActions([
            "sendEvent",
        ]),
        sendLocalHeartbeat(){
            http.get(this.localHeartbeatUrl);
        },
        onMapReady(){
            this.addMapReadyClassToBody();
            this.activateLocalHeartBeatInterval();
        },
        activateLocalHeartBeatInterval(){
            if(this.localHeartbeatInterval && this.localHeartbeatUrl){
                this.localHeartbeatIntervalPointer = setInterval(this.sendLocalHeartbeat, this.localHeartbeatInterval);
            }
        },
        addMapReadyClassToBody(){
            document.body.classList.add('js-map-ready');
        }
    },
    mounted() {
        this.$bus.$on(UI_MAP_READY, this.onMapReady);
    },
    beforeDestroy() {
        this.$bus.$off(UI_MAP_READY, this.onMapReady);
        clearInterval(this.localHeartbeatIntervalPointer);
    },
    render(){ return null }
}
</script>
